import { render } from "./LabDashboardPage.vue?vue&type=template&id=26b1b30d"
import script from "./LabDashboardPage.vue?vue&type=script&lang=js"
export * from "./LabDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__